import { render, staticRenderFns } from "./MinkotuInput.vue?vue&type=template&id=0865cc52&scoped=true"
import script from "./MinkotuInput.vue?vue&type=script&lang=js"
export * from "./MinkotuInput.vue?vue&type=script&lang=js"
import style0 from "./MinkotuInput.vue?vue&type=style&index=0&id=0865cc52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865cc52",
  null
  
)

export default component.exports